module.exports = __webpack_public_path__ + "static/media/r3s4.80217411.jpg";